import { render, staticRenderFns } from "./CadastroFornecedor.vue?vue&type=template&id=aa4fca0c"
import script from "./CadastroFornecedor.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports